export const movies = [
  {
    id: "tao-1997",
    title: "蜜桃成熟时1997",
    year: 1997,
    director: "钱文锜",
    cast: ["李丽珍", "舒淇", "徐锦江", "黄一飞"],
    genre: "爱情",
    region: "香港",
    duration: "95分钟",
    releaseDate: "1997-03-27",
    rating: 7.8,
    popularity: 98,
    cover: "https://readdy.ai/api/search-image?query=vintage%201990s%20Hong%20Kong%20romance%20film%20poster%20style%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20nostalgic%20lighting%2C%20a%20peach%20branch%20motif%20in%20the%20background%2C%20minimal%20elegant%20composition&width=600&height=900&seq=tao1997-cover&orientation=portrait",
    synopsis:
      "《蜜桃成熟时1997》延续了系列一贯的都市情感基调，把镜头对准九十年代末香港的霓虹街头。故事围绕一段在夏夜短暂相遇、却绵延成漫长牵挂的爱情展开：广告公司职员阿杰因一次偶然的拍摄工作结识了独立摄影师小桃，两人在不同的生活节奏里彼此靠近，又因现实与理想的分歧反复推远。影片用大量雨夜、天台与渡轮码头构成视觉母题，把青春里那种甜中带涩的怅惘拍得细腻而克制。",
    plotAnalysis:
      "影片真正的叙事核心并不是爱情本身，而是“时间”。导演用三段式结构把同一段关系拆成相遇、错位与和解，每一段都刻意留下空白，让观众在留白里补全人物的心理。第一幕的明亮与轻快，与第二幕的冷色调形成强烈对位；到第三幕，那颗反复出现的蜜桃不再是情欲符号，而变成可被珍藏的记忆。表演层面上，女主角把羞怯与果敢的切换处理得极有层次，男主角则承担了全部“说不出口”的情绪。结尾处渡轮离港的长镜头，是九十年代港片中最被低估的抒情片段之一。",
    tags: ["经典电影", "90年代", "亚洲电影", "爱情", "香港电影"],
  },
  {
    id: "tao-1993",
    title: "蜜桃成熟时",
    year: 1993,
    director: "霍耀良",
    cast: ["李丽珍", "成奎安", "黄一山"],
    genre: "爱情",
    region: "香港",
    duration: "88分钟",
    releaseDate: "1993-11-18",
    rating: 7.4,
    popularity: 90,
    cover: "https://readdy.ai/api/search-image?query=retro%20early%201990s%20Hong%20Kong%20movie%20poster%2C%20soft%20pink%20and%20beige%20palette%2C%20sunlit%20balcony%20scene%2C%20gentle%20film%20grain%20texture%2C%20romantic%20summer%20atmosphere%2C%20clean%20typographic%20space&width=600&height=900&seq=tao1993-cover&orientation=portrait",
    synopsis:
      "作为系列的开篇之作，《蜜桃成熟时》以一个夏天为背景，讲述年轻女孩在成长与选择之间的摇摆。影片节奏轻快，充满九十年代港式青春片特有的明亮感，把都市年轻群体的友情、懵懂悸动与对未来既期待又不安的心情，用一连串生活化的片段串联起来。",
    plotAnalysis:
      "本片最可贵的是它没有把成长处理成悲情叙事，而是用近乎纪录的松弛感去呈现日常。镜头习惯停留在人物的侧脸与背影上，让情绪自然渗出。它奠定了整个系列“甜而不腻”的基调，也为后续作品提供了可被反复引用的视觉符号——夏天、天台、一个不愿说再见的人。",
    tags: ["经典电影", "90年代", "亚洲电影", "爱情", "香港电影"],
  },
  {
    id: "chungking-1994",
    title: "重庆森林",
    year: 1994,
    director: "王家卫",
    cast: ["梁朝伟", "林青霞", "王菲", "金城武"],
    genre: "剧情",
    region: "香港",
    duration: "102分钟",
    releaseDate: "1994-07-14",
    rating: 8.7,
    popularity: 96,
    cover: "https://readdy.ai/api/search-image?query=nineties%20Hong%20Kong%20art%20film%20poster%2C%20moody%20neon%20night%20alley%20with%20warm%20amber%20lights%2C%20blurred%20motion%20cinematic%20style%2C%20deep%20red%20and%20teal%20accents%2C%20nostalgic%20urban%20mood&width=600&height=900&seq=chungking-cover&orientation=portrait",
    synopsis:
      "两段关于“错过”的都市寓言：失恋的警察在便利店里数着即将过期的凤梨罐头，另一位警察则在快餐店的喧闹中，与一个总在深夜出现的女孩擦肩。影片用碎片化叙事和暧昧的时间感，书写了九十年代香港最著名的孤独图景。",
    plotAnalysis:
      "王家卫用手持摄影与跳切把城市拍成一种情绪而非地点。罐头上的日期是同一个人对时间的具体焦虑，而音乐与重复动作则把日常仪式感推向诗性。它的伟大在于让“错过”成为可以被温柔对待的事，而不只是遗憾。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "comrades-1996",
    title: "甜蜜蜜",
    year: 1996,
    director: "陈可辛",
    cast: ["黎明", "张曼玉", "杨恭如", "曾志伟"],
    genre: "爱情",
    region: "香港",
    duration: "118分钟",
    releaseDate: "1996-11-02",
    rating: 8.6,
    popularity: 94,
    cover: "https://readdy.ai/api/search-image?query=warm%20nostalgic%201990s%20Hong%20Kong%20romance%20poster%2C%20two%20silhouettes%20on%20a%20bicycle%20at%20dusk%2C%20golden%20hour%20light%2C%20soft%20sepia%20and%20rose%20tones%2C%20film%20grain%2C%20tender%20mood&width=600&height=900&seq=comrades-cover&orientation=portrait",
    synopsis:
      "两个从内地来到香港的年轻人，在异乡的街头相遇、相依又分离。影片横跨十年，把个人命运与时代变迁交织在一起，用一首同名歌曲串联起漂泊者的乡愁与爱情。",
    plotAnalysis:
      "陈可辛把宏大时代收进小人物的一餐一饭。自行车后座、除夕的收音机、反复出现的老歌，都是极朴素却极有效的情绪锚点。它证明了最好的爱情片，写的其实是“人在时代里如何安放自己”。",
    tags: ["经典电影", "90年代", "亚洲电影", "爱情", "香港电影"],
  },
  {
    id: "happy-1997",
    title: "春光乍泄",
    year: 1997,
    director: "王家卫",
    cast: ["张国荣", "梁朝伟", "张震"],
    genre: "剧情",
    region: "香港",
    duration: "96分钟",
    releaseDate: "1997-05-30",
    rating: 8.9,
    popularity: 93,
    cover: "https://readdy.ai/api/search-image?query=artsy%20late%201990s%20film%20poster%2C%20rainy%20Buenos%20Aires%20street%20at%20night%2C%20Iguazu%20falls%20hint%20in%20background%2C%20cool%20blue%20green%20with%20warm%20lamp%20glow%2C%20melancholic%20minimal%20composition&width=600&height=900&seq=happy-cover&orientation=portrait",
    synopsis:
      "一对恋人带着一张地图远赴南美，却在一路的争吵与和好中渐渐走向分离。影片把最私密的情感放在了最辽阔的地景里，让孤独有了具体的形状。",
    plotAnalysis:
      "瀑布成为整部电影的情感终点：它意味着共同抵达的愿望，也意味着无法回头的旅程。黑白与彩色的切换不是为了炫技，而是人物内心状态的外化。张国荣与梁朝伟的对手戏充满危险的张力。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "fallen-1995",
    title: "堕落天使",
    year: 1995,
    director: "王家卫",
    cast: ["黎明", "李嘉欣", "莫文蔚", "金城武"],
    genre: "剧情",
    region: "香港",
    duration: "99分钟",
    releaseDate: "1995-09-21",
    rating: 8.2,
    popularity: 85,
    cover: "https://readdy.ai/api/search-image?query=mid%201990s%20Hong%20Kong%20neo%20noir%20poster%2C%20wide%20angle%20street%20with%20neon%20signs%2C%20figures%20walking%20away%2C%20green%20and%20magenta%20glow%2C%20grainy%20texture%2C%20restless%20urban%20mood&width=600&height=900&seq=fallen-cover&orientation=portrait",
    synopsis:
      "杀手、经纪人与一群在深夜游荡的孤独灵魂，在同一座城市里彼此错过。极广角镜头把香港拍得陌生而迷离，构成王家卫影像谱系中最躁动的一章。",
    plotAnalysis:
      "广角造成的畸变本身就是主题：人与人之间的靠近总是失焦的。沉默多于对白，动作多于抒情，却意外地温柔。它让我们看到，喧嚣的夜晚里，孤独也可以很吵。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "ashes-1994",
    title: "东邪西毒",
    year: 1994,
    director: "王家卫",
    cast: ["张国荣", "林青霞", "梁朝伟", "张曼玉"],
    genre: "剧情",
    region: "香港",
    duration: "99分钟",
    releaseDate: "1994-09-17",
    rating: 8.8,
    popularity: 89,
    cover: "https://readdy.ai/api/search-image?query=epic%201990s%20martial%20arts%20film%20poster%2C%20lone%20warrior%20silhouette%20in%20golden%20desert%2C%20dusty%20amber%20and%20deep%20orange%20palette%2C%20wind%20blown%20sand%20texture%2C%20melancholic%20artistic%20tone&width=600&height=900&seq=ashes-cover&orientation=portrait",
    synopsis:
      "沙漠里的客栈，来来往往的江湖人。影片借武侠外壳讲述记忆与遗忘，把最锋利的情感藏在最荒凉的风景之后。",
    plotAnalysis:
      "它是一部关于“记忆”的电影：越想忘掉的，越会记得。对白被写成诗，风景被拍成心境，动作场面反而让位于凝视。结构上的环形叙事让每一次重逢都像一次告别。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "days-1990",
    title: "阿飞正传",
    year: 1990,
    director: "王家卫",
    cast: ["张国荣", "张曼玉", "刘德华", "刘嘉玲"],
    genre: "剧情",
    region: "香港",
    duration: "94分钟",
    releaseDate: "1990-12-15",
    rating: 8.8,
    popularity: 82,
    cover: "https://readdy.ai/api/search-image?query=early%201990s%20Hong%20Kong%20drama%20poster%2C%20lonely%20figure%20by%20a%20mirror%20in%20dim%20room%2C%20warm%20sepia%20and%20deep%20green%20tones%2C%20soft%20shadow%2C%20nostalgic%20cinematic%20mood&width=600&height=900&seq=days-cover&orientation=portrait",
    synopsis:
      "“无脚鸟”的隐喻从此成为一代影迷的共同记忆。影片描摹一个不肯落地的浪子，和他身边那些愿意等待的人。",
    plotAnalysis:
      "它确立了许多后来被反复引用的视觉语法：镜子、钟表、背影、一段独白。真正动人的是它承认了不肯承诺其实也是一种脆弱。最后一分钟的雨夜，是全片情绪的落点。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "once-thief-1991",
    title: "纵横四海",
    year: 1991,
    director: "吴宇森",
    cast: ["周润发", "张国荣", "钟楚红"],
    genre: "动作",
    region: "香港",
    duration: "108分钟",
    releaseDate: "1991-02-02",
    rating: 8.1,
    popularity: 80,
    cover: "https://readdy.ai/api/search-image?query=classic%201990s%20action%20heist%20film%20poster%2C%20three%20stylish%20figures%20in%20suits%2C%20European%20coastal%20backdrop%2C%20warm%20golden%20light%2C%20dynamic%20elegant%20composition%2C%20retro%20glamour&width=600&height=900&seq=once-thief-cover&orientation=portrait",
    synopsis:
      "三位身手不凡的伙伴联手盗取名画，却在友情与爱情之间面临抉择。影片把枪战、飙车与漫画式的浪漫混合得潇洒利落，是港式动作喜剧的标杆。",
    plotAnalysis:
      "吴宇森把“义气”拍成了一种美学。慢镜、白鸽与双枪成为观众记忆的锚点，但支撑故事的是三个人之间既不宣之于口又牢不可破的信任。它让观众相信，潇洒也可以很深。",
    tags: ["经典电影", "90年代", "亚洲电影", "动作", "香港电影"],
  },
  {
    id: "china-odyssey-1995",
    title: "大话西游之月光宝盒",
    year: 1995,
    director: "刘镇伟",
    cast: ["周星驰", "朱茵", "吴孟达", "莫文蔚"],
    genre: "喜剧",
    region: "香港",
    duration: "88分钟",
    releaseDate: "1995-01-21",
    rating: 8.9,
    popularity: 91,
    cover: "https://readdy.ai/api/search-image?query=playful%201995%20Chinese%20fantasy%20comedy%20poster%2C%20monkey%20king%20silhouette%20against%20desert%20dusk%2C%20warm%20orange%20and%20violet%20sky%2C%20whimsical%20yet%20nostalgic%20mood%2C%20starfield&width=600&height=900&seq=odyssey-cover&orientation=portrait",
    synopsis:
      "把经典神话彻底解构成一场笑中带泪的时空穿越大戏。为了挽回一段错过的感情，主人公不断回到过去，却发现越想改变，越会失去。",
    plotAnalysis:
      "它表面上荒诞搞笑，内核却是关于“成长的代价”。当那句告白在最后一刻被说出，整部电影的喜剧外衣被瞬间剥开，露出令人猝不及防的深情。这是九十年代最会隐藏悲伤的喜剧。",
    tags: ["经典电影", "90年代", "亚洲电影", "喜剧", "香港电影"],
  },
  {
    id: "eat-drink-1994",
    title: "饮食男女",
    year: 1994,
    director: "李安",
    cast: ["郎雄", "杨贵媚", "吴倩莲", "王渝文"],
    genre: "剧情",
    region: "台湾",
    duration: "124分钟",
    releaseDate: "1994-08-03",
    rating: 9.0,
    popularity: 84,
    cover: "https://readdy.ai/api/search-image?query=warm%20family%20drama%20film%20poster%2C%20traditional%20Chinese%20banquet%20table%2C%20steaming%20dishes%2C%20cozy%20amber%20and%20cream%20tones%2C%20soft%20domestic%20lighting%2C%20tender%20nostalgic%20mood&width=600&height=900&seq=eat-drink-cover&orientation=portrait",
    synopsis:
      "一位厨艺精湛的父亲与三个性格迥异的女儿，围绕一张餐桌展开关于爱、距离与告别的细腻群像。食物既是日常，也是情感唯一被允许的出口。",
    plotAnalysis:
      "李安用厨房的声音与气味建立叙事节奏，让沉默的父爱有了具体的温度。每一次家庭聚餐都是一次关系的重新洗牌。它让观众明白，好好吃饭本身就是一种深情。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "台湾电影"],
  },
  {
    id: "viva-erotica-1996",
    title: "色情男女",
    year: 1996,
    director: "尔冬升",
    cast: ["张国荣", "莫文蔚", "舒淇"],
    genre: "剧情",
    region: "香港",
    duration: "100分钟",
    releaseDate: "1996-06-06",
    rating: 7.7,
    popularity: 76,
    cover: "https://readdy.ai/api/search-image?query=mid%201990s%20Hong%20Kong%20drama%20poster%2C%20film%20set%20with%20camera%20and%20lights%2C%20warm%20amber%20and%20rose%20tones%2C%20soft%20shadowy%20interior%2C%20reflective%20artistic%20cinematic%20mood&width=600&height=900&seq=viva-cover&orientation=portrait",
    synopsis:
      "一个陷入低谷的导演，在拍摄一部低成本电影的过程中重新找到创作的意义。影片以自嘲又真诚的方式，描绘了电影工业背后的辛酸与热爱。",
    plotAnalysis:
      "它是一部关于“拍电影”的电影，却没有陷入自我感动。它诚实地承认妥协，也温柔地肯定坚持。主角的转变不着痕迹，却令人信服。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
  {
    id: "glass-1998",
    title: "玻璃之城",
    year: 1998,
    director: "张婉婷",
    cast: ["黎明", "舒淇", "吴彦祖"],
    genre: "爱情",
    region: "香港",
    duration: "113分钟",
    releaseDate: "1998-09-03",
    rating: 8.0,
    popularity: 74,
    cover: "https://readdy.ai/api/search-image?query=late%201990s%20Hong%20Kong%20romance%20poster%2C%20couple%20silhouettes%20against%20city%20skyline%20at%20twilight%2C%20soft%20rose%20and%20lavender%20tones%2C%20dreamy%20bokeh%20lights%2C%20bittersweet%20mood&width=600&height=900&seq=glass-cover&orientation=portrait",
    synopsis:
      "跨越数十年的两段爱情，在同一座城市的不同年代里遥遥呼应。记忆与遗憾交织，构成一曲关于时间与城市的抒情诗。",
    plotAnalysis:
      "张婉婷善于把城市拍成回忆的容器。旧照片、老唱片与街景变迁，共同讲述“我们曾经也这样爱过”。结尾的呼应令人怅然，却也释然。",
    tags: ["经典电影", "90年代", "亚洲电影", "爱情", "香港电影"],
  },
  {
    id: "eighteen-springs-1997",
    title: "半生缘",
    year: 1997,
    director: "许鞍华",
    cast: ["黎明", "吴倩莲", "梅艳芳"],
    genre: "爱情",
    region: "香港",
    duration: "111分钟",
    releaseDate: "1997-01-16",
    rating: 8.1,
    popularity: 72,
    cover: "https://readdy.ai/api/search-image?query=1990s%20period%20romance%20film%20poster%2C%20rainy%20old%20Shanghai%20street%20with%20umbrella%2C%20muted%20olive%20and%20rose%20palette%2C%20soft%20misty%20light%2C%20melancholic%20literary%20mood&width=600&height=900&seq=springs-cover&orientation=portrait",
    synopsis:
      "一段被时代与误会拆散的爱情，多年后重逢，只剩一句轻轻的问候。影片克制地讲述命运的错位，把遗憾拍得安静而汹涌。",
    plotAnalysis:
      "许鞍华把原著里最痛的部分处理得极轻，反而更重。雨、站台与旧信构成情感的坐标系。它讲的不是相爱，而是错过之后如何继续生活。",
    tags: ["经典电影", "90年代", "亚洲电影", "爱情", "香港电影"],
  },
  {
    id: "summer-snow-1995",
    title: "女人四十",
    year: 1995,
    director: "许鞍华",
    cast: ["萧芳芳", "乔宏", "罗家英"],
    genre: "剧情",
    region: "香港",
    duration: "101分钟",
    releaseDate: "1995-05-04",
    rating: 8.5,
    popularity: 70,
    cover: "https://readdy.ai/api/search-image?query=1990s%20family%20drama%20poster%2C%20middle%20aged%20woman%20by%20apartment%20window%2C%20warm%20beige%20and%20soft%20coral%20tones%2C%20quiet%20domestic%20lighting%2C%20gentle%20realistic%20mood&width=600&height=900&seq=summer-snow-cover&orientation=portrait",
    synopsis:
      "四十岁的主妇同时面对工作、家庭与照顾老人的重担，在琐碎日常里守住体面与善良。影片以细腻笔触呈现中年女性不被看见的坚韧。",
    plotAnalysis:
      "它拒绝煽情，也用不着煽情。生活的重量藏在一次买菜、一场争执和一个背影里。表演自然到仿佛就是纪录片，让人久久回味。",
    tags: ["经典电影", "90年代", "亚洲电影", "剧情", "香港电影"],
  },
];